document.addEventListener('DOMContentLoaded', function () {
  initArticlePage();
});

function generateSectionId(text) {
  return (
    'section-' +
    text
      .toLowerCase()
      .replace(/\s+/g, '-')
      .replace(/[^\w-]/g, '')
  );
}

function collectSections() {
  const containerTitleMap = {
    'article-text-content-container': '.article-text-content-title',
    'article-key-factors-wrp': '.article-key-factors-item-title',
    'article-long-form-container': '.article-long-form-title',
    'article-multicolumn-container': '.article-multicolumn-item-title',
    'article-image-and-text-wrp': '.article-image-and-text-title',
    'article-faq-wrp': '.article-faq-accordion-title',
  };

  const allContainers = document.querySelectorAll(
    '.article-text-content-container, .article-key-factors-wrp, .article-long-form-container, .article-multicolumn-container, .article-image-and-text-wrp, .article-faq-wrp',
  );

  const sections = [];

  allContainers.forEach((container) => {
    let titleSelector = null;
    for (const [containerClass, titleClass] of Object.entries(containerTitleMap)) {
      if (container.classList.contains(containerClass)) {
        titleSelector = titleClass;
        break;
      }
    }

    if (titleSelector) {
      const titleElement = container.querySelector(titleSelector);
      if (titleElement) {
        const titleText = titleElement.textContent.trim();

        if (!titleElement.id) {
          titleElement.id = generateSectionId(titleText);
        }

        sections.push({
          id: titleElement.id,
          text: titleText,
        });
      }
    }
  });

  return sections;
}

function updateSidebarNavigation(sections) {
  const isDesktop = window.innerWidth >= 768;
  const selectorClass = isDesktop ? '.article-sidebar-nav-container' : '.article-sidebar-nav';
  const sidebarNavs = document.querySelectorAll(selectorClass);

  sidebarNavs.forEach((nav) => {
    const existingLinks = nav.querySelectorAll('.article-sidebar-nav-link');
    existingLinks.forEach((link) => link.remove());

    sections.forEach((section) => {
      const link = document.createElement('button');
      link.dataset.sectionId = section.id;
      link.className = 'article-sidebar-nav-link p2';
      link.textContent = section.text;
      link.style.background = 'none';
      link.style.border = 'none';
      link.style.cursor = 'pointer';
      link.style.textAlign = 'left';
      link.style.padding = '0';
      link.style.font = 'inherit';
      link.style.color = 'inherit';
      nav.appendChild(link);
    });
  });
}

function applyParentClassesToChildren() {
  const parentElements = document.querySelectorAll('.p1, .p2');

  parentElements.forEach((parent) => {
    const parentClass = parent.classList.contains('p1') ? 'p1' : 'p2';
    const allChildren = parent.querySelectorAll('*');

    allChildren.forEach((child) => {
      child.classList.add(parentClass);
    });
  });
}

function updateLinePosition() {
  const activeLink = document.querySelector('.article-sidebar-nav-link.active');
  const lineInner = document.querySelector('.article-sidebar-nav-line-inner');
  const navContainer = document.querySelector('.article-sidebar-nav-container');

  if (!activeLink || !lineInner || !navContainer) return;

  const activeRect = activeLink.getBoundingClientRect();
  const containerRect = navContainer.getBoundingClientRect();

  let offsetTop = activeRect.top - containerRect.top + navContainer.scrollTop;
  let height = activeRect.height + 16;

  if (offsetTop != 0) {
    offsetTop -= 8;
  } else {
    height -= 8;
  }

  lineInner.style.transform = `translateY(${offsetTop}px)`;
  lineInner.style.height = `${height}px`;
}

function setupIntersectionObserver() {
  const observerOptions = {
    root: null,
    rootMargin: '-50% 0px -50% 0px',
    threshold: 0,
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const id = entry.target.id;
        const links = document.querySelectorAll('.article-sidebar-nav-link');

        links.forEach((link) => {
          link.classList.remove('active');
          if (link.dataset.sectionId === id) {
            link.classList.add('active');
            updateLinePosition();
          }
        });
      }
    });
  }, observerOptions);

  const sections = document.querySelectorAll('[id^="section-"]');
  sections.forEach((section) => observer.observe(section));
}

function setupScrollAndResizeListeners() {
  window.addEventListener('resize', updateLinePosition);
  window.addEventListener('scroll', updateLinePosition);
}

function setInitialActiveLink() {
  const firstLink = document.querySelector('.article-sidebar-nav-link');
  if (firstLink) {
    firstLink.classList.add('active');
    setTimeout(updateLinePosition, 100);
  }
}

function setupNavigationClickHandlers() {
  const navLinks = document.querySelectorAll('.article-sidebar-nav-link');
  navLinks.forEach((link) => {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      const sectionId = this.dataset.sectionId;
      const targetSection = document.getElementById(sectionId);

      if (targetSection) {
        targetSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(updateLinePosition, 300);
      }
    });
  });
}

function initScrollIndicator() {
  setupIntersectionObserver();
  setupScrollAndResizeListeners();
  setInitialActiveLink();
  setupNavigationClickHandlers();
}

function initArticlePage() {
  const sections = collectSections();
  updateSidebarNavigation(sections);
  applyParentClassesToChildren();
  initScrollIndicator();
}
